import { Component, OnInit } from '@angular/core';
import { AuthStore } from '@lemsar/storage/stores/auth.store';
import { first, map } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
    selector: 'naker-landing-page',
    template: 'Silahkan tunggu...',
})
export class LandingPage implements OnInit {
    public constructor(private authStore: AuthStore, private router: Router) {}

    public ngOnInit(): void {
        this.authStore.user$
            .pipe(
                first(),
                map(user => {
                    if (user.hasRole('admin')) {
                        this.router.navigate(['/dashboards']);
                    } else {
                        this.router.navigate(['/institutions']);
                    }

                    return false;
                }),
            )
            .subscribe();
    }
}



// WEBPACK FOOTER //
// ./apps/frontend/src/views/pages/landing.page.ts